<div class="customer-dialog-container">
    <div class="header" mat-dialog-actions>
        <div class="navigation desktop">
            <div class="left">
                <button mat-button (dblclick)="delete()">Delete</button>
            </div>
            <div class="middle">
                <!-- <button mat-button (click)="previous()">Previous</button>
                <button mat-button (click)="next()">Next</button> -->
            </div>
            <div class="right">
                <button mat-button (click)="cancel()">Cancel</button>
                <button mat-button (click)="saveAndClose()">Save</button>
            </div>
        </div>

        <div class="navigation mobile">
            <div class="left">
                <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
            </div>
            <div class="middle">
                <!-- <button mat-button (click)="previous()">Previous</button>
                <button mat-button (click)="next()">Next</button> -->
            </div>
            <div class="right">
                <button mat-button (click)="delete()">Delete</button>
                <button mat-button (click)="saveAndClose()">Save</button>
            </div>
        </div>
    </div>

    <div class="content">

        <div class="side-nav">
            <button (click)="tab = 'customer'" mat-raised-button>Customer</button>
            <button (click)="tab = 'business'" mat-raised-button>Business</button>
            <button (click)="tab = 'rcti'" mat-raised-button>RCTI</button>
            <button (click)="tab = 'notes'" mat-raised-button>Notes</button>
            <button (click)="tab = 'invoices'" mat-raised-button>Invoices</button>
            <button (click)="tab = 'review'" mat-raised-button>Google Review</button>
        </div>

        <div class="main-content">
            <div *ngIf="tab == 'customer'">
                <div class="tab-body">
                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Customer</mat-label>
                        <input [(ngModel)]="customer.name" matInput>
                    </mat-form-field>

                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input type="email" [(ngModel)]="customer.email" matInput>
                    </mat-form-field>

                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Phone</mat-label>
                        <input type="tel" [(ngModel)]="customer.phone" matInput>
                    </mat-form-field>

                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Phone 2</mat-label>
                        <input type="tel" [(ngModel)]="customer.phone2" matInput>
                    </mat-form-field>

                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Address</mat-label>
                        <input type="tel" [(ngModel)]="customer.address" matInput>
                    </mat-form-field>

                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Google review status</mat-label>
                        <mat-select [(ngModel)]="customer.googleReviewStatus">
                            <mat-option value="not_requested">No review request sent</mat-option>
                            <mat-option value="requested">Review request sent</mat-option>
                            <mat-option value="left">Review left</mat-option>
                            <mat-option value="do_not_request">Do not request</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Tags</mat-label>
                        <input [(ngModel)]="customer.tags" matInput>
                    </mat-form-field> -->
                </div>
            </div>

            <div *ngIf="tab == 'business'">
                <div class="tab-body">
                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Business Owner</mat-label>
                        <input [(ngModel)]="customer.owner" matInput>
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>ABN</mat-label>
                        <input [(ngModel)]="customer.abn" matInput>
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>NDIS</mat-label>
                        <input [(ngModel)]="customer.ndis" matInput>
                    </mat-form-field>
                </div>
            </div>

            <div *ngIf="tab == 'rcti'">
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Drivers License</mat-label>
                    <input [(ngModel)]="customer.driversLicenseNumber" matInput>
                </mat-form-field>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Bank BSB Number</mat-label>
                    <input [(ngModel)]="customer.bankAccNumber" matInput>
                </mat-form-field>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Bank Account Number</mat-label>
                    <input [(ngModel)]="customer.bankBSBNumber" matInput>
                </mat-form-field>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>GST Status</mat-label>
                    <mat-select [(value)]="customer.gstStatus">
                      <mat-option [value]="true">Yes</mat-option>
                      <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="tab=='notes'">
                <div class="tab-body">
                    <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                        <mat-label>Notes</mat-label>
                        <textarea class="notes" [(ngModel)]="customer.notes" matInput></textarea>
                    </mat-form-field>
                </div>
            </div>

            <div *ngIf="tab == 'invoices'">
                <div class="tab-body invoices-tab">
                    <div class="invoices-header">
                        <div>
                            <p class="eyebrow">Invoices</p>
                            <p class="hint">Invoices linked to this customer.</p>
                        </div>
                        <button mat-stroked-button color="primary" type="button" (click)="loadInvoices()" [disabled]="invoicesLoading">
                            {{ invoicesLoading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                    </div>

                    <div *ngIf="invoicesError" class="error">{{ invoicesError }}</div>
                    <div *ngIf="invoicesLoading" class="pill muted">Loading invoices…</div>
                    <div *ngIf="!invoicesLoading && !invoicesError && invoices.length === 0" class="pill muted">No invoices found for this customer.</div>

                    <div *ngIf="!invoicesLoading && !invoicesError && invoices.length > 0" class="invoices-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let inv of invoices" (click)="openInvoice(inv)">
                                    <td>{{ inv.number }}</td>
                                    <td>{{ inv.dateCreated | date:'shortDate' }}</td>
                                    <td class="status">{{ inv.status }}</td>
                                    <td>{{ inv.total | human }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div *ngIf="tab == 'review'">
                <div class="tab-body review-tab">
                    <div class="review-section mat-elevation-z1">
                        <div class="review-header">
                            <div>
                                <p class="eyebrow">Google review SMS</p>
                                <p class="hint">Render and send a review request right from this dialog.</p>
                                <p class="status-pill">Current status: {{ reviewStatusLabel(customer.googleReviewStatus) }}</p>
                            </div>
                            <button
                                mat-flat-button
                                color="primary"
                                type="button"
                                (click)="sendReviewSMS()"
                                [disabled]="reviewSending">
                                {{ reviewSending ? 'Sending...' : 'Send SMS' }}
                            </button>
                        </div>
                        <div class="review-fields">
                            <mat-form-field appearance="outline">
                                <mat-label>Template</mat-label>
                                <mat-select [(ngModel)]="reviewTemplate">
                                    <mat-option *ngFor="let t of reviewTemplates" [value]="t.id">{{ t.label }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="error" *ngIf="reviewError">{{ reviewError }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
